// extracted by mini-css-extract-plugin
export var dropdownButton = "_4c-0";
export var fullWidthDropdownButton = "_4c-1";
export var icon = "_4c-3";
export var iconPlaceholder = "_4c-2";
export var menuItemRow = "_4c-9";
export var separator = "_4c-e";
export var shortcutContainer = "_4c-7";
export var shortcutContainerFilled = "_4c-8";
export var shortcutIconLg = "_4c-6";
export var shortcutIconMd = "_4c-5";
export var shortcutIconSm = "_4c-4";
export var submenuChevron = "_4c-d";
export var submenuDropdown = "_4c-a";
export var submenuTriggerRow = "_4c-b";
export var submenuTriggerRowOpen = "_4c-c";